import React from "react";
import {
    FormSection, FormSectionHeader, FormSectionBody,
    RiskContainer, RiskCard, RiskLevelBadge,
} from "./LabourWardStyles";

/**
 * LabourRiskAssessment — Pre-delivery risk assessment checklist
 */
export const LabourRiskAssessment = function(props) {
    const riskFactors = props.riskFactors;
    const toggleRiskFactor = props.toggleRiskFactor;
    const riskLevel = props.riskLevel;
    const RISK_FACTORS = props.RISK_FACTORS;

    const selectedCount = riskFactors.length;

    /* Risk level display */
    const riskLevelLabel = {
        critical: "🔴 Critical Risk",
        high: "🟠 High Risk",
        medium: "🟡 Medium Risk",
        low: "🟢 Low Risk",
    };

    /* Group by severity */
    const criticalFactors = RISK_FACTORS.filter(function(f) { return f.severity === "critical"; });
    const highFactors = RISK_FACTORS.filter(function(f) { return f.severity === "high"; });
    const mediumFactors = RISK_FACTORS.filter(function(f) { return f.severity === "medium"; });

    const renderGroup = function(title, factors, emoji) {
        return React.createElement("div", { style: { marginBottom: 20 } },
            React.createElement("div", {
                style: { fontSize: "0.82rem", fontWeight: 700, color: "#263238",
                    marginBottom: 10, display: "flex", alignItems: "center", gap: 6 }
            }, emoji, " ", title),
            React.createElement(RiskContainer, null,
                factors.map(function(factor) {
                    const isChecked = riskFactors.indexOf(factor.key) >= 0;
                    return React.createElement(RiskCard, {
                        key: factor.key,
                        checked: isChecked,
                        severity: factor.severity,
                        onClick: function() { toggleRiskFactor(factor.key); },
                    },
                        React.createElement("div", { className: "risk-check" },
                            isChecked ? "✓" : ""
                        ),
                        React.createElement("span", { className: "risk-label" }, factor.label),
                        React.createElement("span", { className: "risk-severity" }, factor.severity)
                    );
                })
            )
        );
    };

    return React.createElement(FormSection, null,
        React.createElement(FormSectionHeader, { bg: "#fff8e1", color: "#e65100" },
            React.createElement("h4", null, "⚡ Pre-Delivery Risk Assessment"),
            React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } },
                React.createElement(RiskLevelBadge, { level: riskLevel },
                    riskLevelLabel[riskLevel] || "Low Risk"
                ),
                selectedCount > 0
                    ? React.createElement("span", { className: "sh-badge" },
                        selectedCount + " identified"
                    ) : null
            )
        ),
        React.createElement(FormSectionBody, null,
            React.createElement("p", {
                style: { fontSize: "0.8rem", color: "#78909c", margin: "0 0 16px",
                    fontStyle: "italic" }
            }, "Select all risk factors that apply to this patient. This helps classify the delivery risk level and ensures appropriate preparation."),

            renderGroup("Critical Risk Factors", criticalFactors, "🔴"),
            renderGroup("High Risk Factors", highFactors, "🟠"),
            renderGroup("Medium Risk Factors", mediumFactors, "🟡"),

            selectedCount === 0
                ? React.createElement("div", {
                    style: {
                        textAlign: "center", padding: "16px", background: "#e8f5e9",
                        borderRadius: 8, border: "1px solid #a5d6a7",
                        fontSize: "0.84rem", fontWeight: 600, color: "#2e7d32",
                    }
                }, "✅ No risk factors identified — Low risk delivery")
                : null
        )
    );
};
